import {cva} from 'class-variance-authority';

export const typographyVariants = cva('text-foreground', {
  variants: {
    variant: {
      default: 'font-normal',
      display1: 'type-display1',
      h1: 'type-h1',
      h2: 'type-h2',
      h3: 'type-h3',
      h4: 'type-h4',
      h5: 'type-h5',
      h6: 'type-h6',
      body1: 'type-body1',
      body2: 'type-body2',
      body2Regular: 'type-body2-regular',
      label: 'type-label',
      caption: 'type-caption',
      navigation: 'type-navigation',
      buttonSmall: 'type-btn-sm',
      buttonDefault: 'type-btn-default',
      buttonLarge: 'type-btn-lg',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
